import { getAPIUrl } from '../helpers/App';

export const APIintegrations = () => (
  window.axios.get(getAPIUrl('/integrations'))
    .then(response => (response.data))
);

export const APIintegrationGet = (serviceId, params = {}) => (
  window.axios.get(getAPIUrl(`/integrations/${serviceId}`), { params: { ...params } })
    .then(response => (response.data))
);

export const APIintegrationExchangeCodeToAccessToken = (serviceId, code) => (
  window.axios.post(getAPIUrl(`/integrations/${serviceId}/access_token`), { code })
    .then(response => (response.data))
);

export const APIintegrationGetAccounts = (serviceId, code = undefined) => (
  window.axios.get(getAPIUrl(`/integrations/${serviceId}/accounts`), { params: { code } })
    .then(response => (response.data))
);

export const APIintegrationConnect = (serviceId, params) => (
  window.axios.post(getAPIUrl(`/integrations/${serviceId}/connect`), params)
    .then(response => (response.data))
);

export const APIintegrationDisconnect = serviceId => (
  window.axios.post(getAPIUrl(`/integrations/${serviceId}/disconnect`))
    .then(response => (response.data))
);

export const APIintegrationCheckConnectionRequestStatus = requestId => (
  window.axios.get(getAPIUrl(`/integrations/requests/${requestId}`))
    .then(response => (response.data))
);

export const APIintegrationAuthenticateExternalUser = (serviceId, token) => (
  window.axios.post(getAPIUrl(`/integrations/${serviceId}/auth`), { token })
    .then(response => (response.data))
);

export const APIintegrationCallMethod = (serviceId, method, params = {}) => (
  window.axios.post(getAPIUrl(`/integrations/${serviceId}/method`), { method, ...params })
    .then(response => (response.data))
);
